module.exports = __webpack_public_path__ + "static/media/ao.ede40421.svg";